<div mat-dialog-title>
  <h2>{{"content2.Edit Main Info" | translate}}</h2>
  <button mat-icon-button class="close" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup">

  <mat-dialog-content>
    <div class="mat-dialog-body">
      <div *ngIf='dataLoading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
      <ng-container *ngIf="!dataLoading">
        <div class="fields-group">
          <div class="image-uploader">
            <div class="upload-container">
              <label [for]="'fileUploadInputBanner'">
                <input type='file' class="img-viewer" [id]="'fileUploadInputBanner'"
                  accept="image/jpeg, image/pjpeg, image/png" (change)="changeFileListener($event, 0)">
                <div class="image-preview banner no-border">
                  <img [src]="bannerSrc" *ngIf="bannerSrc">
                </div>
              </label>
            </div>
            <div style="width: 50%;">
              <label>{{ 'restaurant.Profile Banner' | translate }}</label>
              <p>
                {{ 'content.JPG or PNG' | translate }}
                <span>({{ 'content.MB max' | translate: {no: 2} }})</span>
              </p>
              <p class="info font-12">{{'restaurant.This banner will appear on the restaurants profile screen in the guest app' | translate }}</p>
            </div>
          </div>
          <p class="has-error" *ngIf="!bannerSrc && isSubmitted && !(bannerTypeError || bannerSizeError)">
            {{ 'forms.Required' | translate }}
          </p>
          <p class="has-error" *ngIf="bannerTypeError">
            {{ 'forms.InvalidFile' | translate }}
          </p>
          <p class="has-error" *ngIf="bannerSizeError">
            {{ 'forms.Max-file-size' | translate }}
            {{maxBannerSize}} {{ 'forms.MB' | translate }}
          </p>
        </div>

        <div class="fields-group">
          <div class="image-uploader">
            <div class="upload-container">
              <label [for]="'fileUploadInput'">
                <input type='file' class="img-viewer" [id]="'fileUploadInput'"
                  accept="image/jpeg, image/pjpeg, image/png" (change)="changeFileListener($event, 1)">
                <div class="image-preview photo no-border">
                  <img [src]="logoSrc" *ngIf="logoSrc">
                </div>
              </label>
            </div>
            <div>
              <label>{{ 'forms.Profile Image' | translate }}</label>
              <p>
                {{ 'content.JPG or PNG' | translate }}
                <span>({{ 'content.MB max' | translate: {no: 1} }})</span>
              </p>
            </div>
          </div>
          <p class="has-error" *ngIf="!logoSrc && isSubmitted && !(fileTypeError || fileSizeError)">
            {{ 'forms.Required' | translate }}
          </p>
          <p class="has-error" *ngIf="fileTypeError">
            {{ 'forms.InvalidFile' | translate }}
          </p>
          <p class="has-error" *ngIf="fileSizeError">
            {{ 'forms.Max-file-size' | translate }}
            {{maxFileSize}} {{ 'forms.MB' | translate }}
          </p>
        </div>

        <div class="fields-group">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field hideRequiredMarker>
                <mat-label *ngIf="formGroup.controls['restaurantType'].value == 'Main'">{{"forms.Restaurant name in English" | translate}}</mat-label>
                <mat-label *ngIf="formGroup.controls['restaurantType'].value == 'Branch'">{{"forms.Restaurant name in English" | translate}}</mat-label>
                <input matInput maxlength="50" formControlName="title_EN">
                <mat-error *ngIf="hasError(formGroup, 'title_EN', 'required')">
                  {{ 'forms.Required' | translate }}
                </mat-error>
                <!-- <mat-error *ngIf="hasError(formGroup, 'title_EN', 'pattern')">
                  {{ 'forms.EntervalidNameinEnglish' | translate }}
                </mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="arabic-title" hideRequiredMarker>
                <mat-label *ngIf="formGroup.controls['restaurantType'].value == 'Main'">{{"forms.Restaurant name in Arabic" | translate}}</mat-label>
                <mat-label *ngIf="formGroup.controls['restaurantType'].value == 'Branch'">اسم الفرع باللغة العربية</mat-label>
                <input matInput maxlength="50" formControlName="title_AR">
                <mat-error *ngIf="hasError(formGroup, 'title_AR', 'required')">
                  {{ 'forms.Required' | translate }}</mat-error>
                <!-- <mat-error *ngIf="hasError(formGroup, 'title_AR', 'pattern')">
                  {{ 'forms.EntervalidNameinArabic' | translate }}
                </mat-error> -->
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{"forms.Branch Short Name (Abbreviation)" | translate}}</mat-label>
                <input matInput maxlength="50" formControlName="shortName">
                <mat-error *ngIf="hasError(formGroup, 'shortName', 'required')">
                  {{ 'forms.Required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <app-phone-number [formGroup]="formGroup"
            [controlName]="'phone'" name="phone"
            [isSubmitted]='isSubmitted' [selectedCountry]="selectedCountry" [required]="true">
          </app-phone-number>

          <mat-form-field hideRequiredMarker>
            <mat-label>{{"forms.Email" | translate}}</mat-label>
            <input matInput formControlName="mail" maxlength="50" type="email">
            <mat-error *ngIf="hasError(formGroup, 'mail', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <mat-error *ngIf="hasError(formGroup, 'mail', 'invalid')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
            <mat-error *ngIf="hasError(formGroup, 'mail', 'pattern')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field hideRequiredMarker>
            <mat-label>{{"forms.VAT number" | translate}}</mat-label>
            <input matInput formControlName="vatNumber" maxlength="15" appOnlynumber>
            <mat-error *ngIf="hasError(formGroup, 'vatNumber', 'required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
          </mat-form-field>

          <div [hidden]="formGroup.controls['restaurantType'].value == 'Branch'">
            <mat-form-field hideRequiredMarker>
              <mat-label>{{"forms.Website" | translate}}</mat-label>
              <input matInput formControlName="website">
              <mat-error *ngIf="hasError(formGroup, 'website', 'pattern')">
                {{ 'forms.Invalid-Website' | translate }}
              </mat-error>
              <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <mat-form-field hideRequiredMarker>
              <mat-label>{{"forms.Latitude" | translate}}</mat-label>
              <input matInput formControlName="latitude" maxlength="20">
              <mat-error *ngIf="hasError(formGroup, 'latitude', 'required')">
                {{ 'forms.Required' | translate }}
              </mat-error>
              <mat-error *ngIf="hasError(formGroup, 'latitude', 'pattern')">
                {{ 'forms.Invalid value' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field hideRequiredMarker>
              <mat-label>{{"forms.Longitude" | translate}}</mat-label>
              <input matInput formControlName="longitude" maxlength="20">
              <mat-error *ngIf="hasError(formGroup, 'longitude', 'required')">
                {{ 'forms.Required' | translate }}
              </mat-error>
              <mat-error *ngIf="hasError(formGroup, 'longitude', 'pattern')">
                {{ 'forms.Invalid value' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div>
          <mat-form-field hideRequiredMarker>
            <mat-label>{{ 'forms.Country' | translate }}</mat-label>
            <mat-select formControlName="countryId" (selectionChange)="cityParentChange($event.value);"
            [class.loading-field]="countryLoading">
              <mat-option [value]="item.id" *ngFor="let item of countries">
                <span>{{item.name}}</span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError(formGroup, 'countryId', 'required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field hideRequiredMarker>
            <mat-label>{{ 'forms.City' | translate }}</mat-label>
            <mat-select formControlName="cityId" [class.loading-field]="cityLoading" [disabled]="cityLoading">
              <mat-option [value]="item.id" *ngFor="let item of cities">
                <span>{{item.name}}</span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError(formGroup, 'cityId', 'required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field hideRequiredMarker>
            <mat-label>{{"forms.Street" | translate}} - {{'forms.English' | translate}}</mat-label>
            <input matInput formControlName="streetEn" maxlength="320">
            <mat-error *ngIf="hasError(formGroup, 'streetEn', 'required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
            <!-- <mat-error *ngIf="hasError(formGroup, 'streetEn', 'pattern')">
              {{ 'forms.EntervalidStreetinEnglish' | translate }}
            </mat-error> -->
          </mat-form-field>
          <mat-form-field hideRequiredMarker>
            <mat-label>{{"forms.Street" | translate}} - {{'forms.Arabic' | translate}}</mat-label>
            <input matInput formControlName="streetAr" maxlength="320">
            <mat-error *ngIf="hasError(formGroup, 'streetAr', 'required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
            <!-- <mat-error *ngIf="hasError(formGroup, 'streetAr', 'pattern')">
              {{ 'forms.EntervalidStreetinArabic' | translate }}
            </mat-error> -->
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="autocomplete-field"
            [class.loading-field]="cuisinesLoading">
            <mat-label>{{"content2.Select cuisines" | translate}}</mat-label>

            <input type="text" matInput [formControl]="cuisinCtr"
              [matAutocomplete]="auto" (blur)="checkCuisines()">

            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let item of filteredCuisines | async" [value]="item">
                <div (click)="$event.stopPropagation(); cuisinSelected(item)">
                  <mat-checkbox
                    [checked]="isSelected(item)"
                    (change)="cuisinSelected(item)"
                    (click)="$event.stopPropagation()">
                    {{item.name}}
                  </mat-checkbox>
                </div>
              </mat-option>
            </mat-autocomplete>

            <mat-error *ngIf="cuisinCtr.hasError('required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
          </mat-form-field>

          <div>
            <ul class="chips-selected">
              <li *ngFor="let item of selectedCuisines; index as index">
                {{item.name}}
                <span class="remove" (click)="removeCuisin(index)">&times;</span>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <p class="mt-4">{{"restaurant.Social Media Links" | translate}}</p>
          <div class="row mt-3">
            <div class="col-6 mb-2">
              <app-phone-number [formGroup]="formGroup"
                [controlName]="'whatsapp'" name="whatsapp" [label]="'restaurant.Whatsapp' | translate"
                [isSubmitted]='isSubmitted' [selectedCountry]="selectedWhatsappCountry" [required]="false">
              </app-phone-number>
              <!-- <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Whatsapp' | translate }}</mat-label>
                <input matInput formControlName="whatsapp">
                <mat-error *ngIf="hasError(formGroup, 'whatsapp', 'pattern')">
                  {{ 'forms.Invalid value' | translate }}
                </mat-error>
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field> -->
            </div>
            <div class="col-6 mb-2">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Facebook Link' | translate }}</mat-label>
                <input matInput formControlName="facebook">
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-6 mb-2">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Twitter Link' | translate }}</mat-label>
                <input matInput formControlName="twitter">
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-6 mb-2">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Instagram Link' | translate}}</mat-label>
                <input matInput formControlName="instagram">
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-6 mb-2">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Snapchat Link' | translate }}</mat-label>
                <input matInput formControlName="snapchat">
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-6 mb-2">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Tiktok Link' | translate }} </mat-label>
                <input matInput formControlName="tiktok">
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-6 mb-2">
              <mat-form-field hideRequiredMarker>
                <mat-label>{{'restaurant.Youtube Link' | translate }}</mat-label>
                <input matInput formControlName="youtube">
                <mat-hint>{{'forms.Optional' | translate}}</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

      </ng-container>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button class="btn-grey" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>

    <button mat-raised-button color="primary"
        [disabled]="loading"
        (click)="saveRecord()"
        [class.loading]="loading">
      {{ 'content2.Update Info' | translate }}
    </button>
  </mat-dialog-actions>
</form>
